<ng-container *ngFor="let item of actionList">
  <nz-form-item *ngIf="item === 'RejectReview' || item === 'TakeDown'">
    <nz-form-label nzFor="Reason" nzRequired>Reason</nz-form-label>
    <textarea nz-input [(ngModel)]="input" [nzAutosize]="{ minRows: 3}">
    </textarea>
  </nz-form-item>
  <button type="button" nz-button nzType="primary" (click)="updateStatus(item)">{{item}}</button>  
</ng-container>
